import { Tabs } from "antd";
import { StickyContainer, Sticky } from "react-sticky";
import DatosSolicitantesSection from "./sections/DatosSolicitantesSection";
import DatosEmisionInformeFacturaSection from "./sections/DatosEmisionInformeFacturaSection"
import DatosEnvioMuestraSection from "./sections/DatosEnvioMuestraSection"
import DatosServiciosSection from "./sections/DatosServiciosSection"
import PuntosMuestreoSection from "./sections/PuntosMuestreoSection" 
import { BasePage } from "../../../../framework/pages/BasePage";
import "../tabs.css";

export class PlanificacionSejecutadosPage extends BasePage {
  
  constructor(props) {
    super(props);
    this.state = {
      validarDatosAnalisisSection: false,
      // keyPrincipal: "1",
      keyPanel: "1"
    }
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this)
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      validarDatosAnalisisSection: true,
      keyPrincipal: tab,
      keyPanel: tab
    })
  }

  componentDidMount() {
    sessionStorage.removeItem("datos_emision_informe_factura");
    let estado_tab = window.location.pathname.split('/')[3]

    if (estado_tab === "new") {
      this.setState({
        keyPanel: "1",
        keyPrincipal: "1"
      })
    }
    else {
      this.setState({
        // id_doc: obtenerId,
        keyPanel: estado_tab,
        keyPrincipal: estado_tab
      })
    }
  }

  componentWillUnmount() {
    setTimeout(() => {
      sessionStorage.removeItem("datos_emision_informe_factura");
    }, 100);
  }

  renderPage(pageApi) {
    const { TabPane } = Tabs;

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    return ( 
      <>
        <StickyContainer>
          <Tabs destroyInactiveTabPane={true} activeKey={this.state.keyPanel} renderTabBar={renderTabBar} onChange={(key) => this.setState({ keyPanel: key })}>
            <TabPane tab="Datos del Solicitante" key="1">
              <DatosSolicitantesSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/>
            </TabPane>

            <TabPane tab="Datos de Servicio" key="2" disabled={parseInt(this.state.keyPrincipal) < 2}>
              <DatosServiciosSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/>
            </TabPane>

            <TabPane tab="Puntos de Muestreo" key="3" disabled={parseInt(this.state.keyPrincipal) < 3}>
              <PuntosMuestreoSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/>
            </TabPane>

            <TabPane tab="Datos de Envio de la muestra" key="4" disabled={parseInt(this.state.keyPrincipal) < 4}>
              <DatosEnvioMuestraSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/>
            </TabPane>

            <TabPane tab="Datos de Emision de Informe y Factura" key="5" disabled={parseInt(this.state.keyPrincipal) < 5}>
              <DatosEmisionInformeFacturaSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history}/>
            </TabPane>
          </Tabs>
        </StickyContainer>
      </>
    );
  }
}